import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';

@Component({
  selector: 'app-filtro-periodo',
  templateUrl: './filtro-periodo.component.html',
  styleUrls: ['./filtro-periodo.component.scss']
})
export class FiltroPeriodoComponent implements OnInit {

  @Input() tipos: string[] = []; // ['vencimento', 'pagamento'...]
  @Input() mostrarEmitir: boolean = false;
  @Input() mostrarPesquisar: boolean = false;
  @Output() change = new EventEmitter<any>();
  @Output() emitir = new EventEmitter<any>();
  @Output() pesquisar = new EventEmitter<any>();

  modoManual = false;

  multi: any = {};
  initStateMulti = true;
  mesesSelecionados: any = {};
  filters: any = {};

  mesesRapidos: any[] = [];

  ngOnInit() {
    this.initState();
    this.mesesRapidos = this.getMesesRapidos();
  }

  initState() {
    this.tipos.forEach(tipo => {
      this.multi[tipo] = this.initStateMulti;
      this.mesesSelecionados[tipo] = [];
      this.filters[tipo] = {
        ini: null,
        fim: null
      };
    });
  }

  emitirRelatorio() {
    this.emitir.emit(this.getPayload());
  }

  pesquisarDados() {
    this.pesquisar.emit(this.getPayload());
  }

  emitChange() {
    this.change.emit(this.getPayload());
  }

  getPayload() {
    const retorno: any = {};

    this.tipos.forEach(tipo => {
      retorno[tipo] = {
        ini: this.filters[tipo]?.ini,
        fim: this.filters[tipo]?.fim
      };
    });

    return retorno;
  }

  getMesesRapidos() {
    const meses = [];
    const hoje = new Date();

    for (let i = 0; i <= 7; i++) {
      const data = new Date(hoje.getFullYear(), hoje.getMonth() - i, 1);

      const label = data.toLocaleDateString('pt-BR', {
        month: 'long',
        // month: 'short',
        year: 'numeric'
      });

      meses.push({
        label: label.charAt(0).toUpperCase() + label.slice(1),
        value: `${data.getFullYear()}-${data.getMonth()}`
      });
    }

    return meses;
  }

  getMesNumero(valor: string): number {
    const [ano, mes] = valor.split('-').map(Number);
    return ano * 12 + mes;
  }

  gerarIntervaloMeses(inicio: string, fim: string): string[] {
    const meses: string[] = [];

    let atual = this.getMesNumero(inicio);
    const final = this.getMesNumero(fim);

    while (atual <= final) {
      const ano = Math.floor(atual / 12);
      const mes = atual % 12;

      meses.push(`${ano}-${mes}`);

      atual++;
    }

    return meses;
  }

  toggleMes(tipo: string, valor: string) {
    const isMulti = this.multi[tipo];
    let lista = this.mesesSelecionados[tipo];

    // =========================
    // MODO SIMPLES (ajuste)
    // =========================
    if (!isMulti) {

      if (lista.length === 1 && lista[0] === valor) {
        this.mesesSelecionados[tipo] = [];
      } else {
        this.mesesSelecionados[tipo] = [valor];
      }

    } else {

      const index = lista.indexOf(valor);

      // =========================
      // REMOVE NORMAL
      // =========================
      if (index > -1) {

        if (lista.length >= 2) {

          const ordenado = [...lista].sort(
            (a, b) => this.getMesNumero(a) - this.getMesNumero(b)
          );

          const inicio = ordenado[0];
          const fim = ordenado[ordenado.length - 1];

          const numValor = this.getMesNumero(valor);
          const numInicio = this.getMesNumero(inicio);
          const numFim = this.getMesNumero(fim);

          // meio → corta mantendo os mais recentes
          if (numValor > numInicio && numValor < numFim) {
            this.mesesSelecionados[tipo] = this.gerarIntervaloMeses(valor, fim);
          } 
          else {

            // NOVA REGRA
            if (valor === inicio) {
              this.mesesSelecionados[tipo] = [inicio];
            } else if (valor === fim) {
              this.mesesSelecionados[tipo] = [fim];
            }
          }

        } else {
          lista.splice(index, 1);
        }
      } else {

        // =========================
        // ADD NORMAL
        // =========================
        lista.push(valor);

        // =========================
        // NORMALIZA RANGE (igual seu)
        // =========================
        if (lista.length >= 2) {

          const ordenado = [...lista].sort(
            (a, b) => this.getMesNumero(a) - this.getMesNumero(b)
          );

          const inicio = ordenado[0];
          const fim = ordenado[ordenado.length - 1];

          this.mesesSelecionados[tipo] = this.gerarIntervaloMeses(inicio, fim);
        }
      }
    }

    this.aplicarPeriodo(tipo);
    this.emitChange();
  }

  aplicarPeriodo(tipo: string) {
    const lista = this.mesesSelecionados[tipo];
    if (!lista.length) {
      this.filters[tipo].ini = null;
      this.filters[tipo].fim = null;
      return;
    }

    const datas = lista.map(valor => {
      const [ano, mes] = valor.split('-').map(Number);
      return new Date(ano, mes, 1);
    });

    const menor = new Date(Math.min(...datas.map(d => d.getTime())));
    const maior = new Date(Math.max(...datas.map(d => d.getTime())));

    const inicio = new Date(menor.getFullYear(), menor.getMonth(), 1);
    const fim = new Date(maior.getFullYear(), maior.getMonth() + 1, 0);

    this.filters[tipo].ini = this.formatDate(inicio);
    this.filters[tipo].fim = this.formatDate(fim);
  }

  formatDate(date: Date): string {
    const ano = date.getFullYear();
    const mes = String(date.getMonth() + 1).padStart(2, '0');
    const dia = String(date.getDate()).padStart(2, '0');
    return `${ano}-${mes}-${dia}`;
  }

  formatDateBR(date: Date): string {
    const dia = String(date.getDate()).padStart(2, '0');
    const mes = String(date.getMonth() + 1).padStart(2, '0');
    const ano = date.getFullYear();
    return `${dia}/${mes}/${ano}`;
  }

  getPeriodoTexto(tipo: string): string {

    const lista = this.mesesSelecionados[tipo];
    if (!lista.length) return '';

    const datas = lista.map(valor => {
      const [ano, mes] = valor.split('-').map(Number);
      return new Date(ano, mes, 1);
    });

    const menor = new Date(Math.min(...datas.map(d => d.getTime())));
    const maior = new Date(Math.max(...datas.map(d => d.getTime())));

    const inicio = new Date(menor.getFullYear(), menor.getMonth(), 1);
    const fim = new Date(maior.getFullYear(), maior.getMonth() + 1, 0);

    return `${this.formatDateBR(inicio)} - ${this.formatDateBR(fim)}`;
  }

  limpar() {
    this.modoManual = false;
    this.initState();
    this.emitChange();
  }

  getConfigTipo(tipo: string) {
    const map: any = {
      vencimento: {
        color: 'primary',
        icon: 'fa-calendar-alt',
        label: 'Vencimento'
      },
      producao: {
        color: 'info',
        icon: 'fa-calendar-check',
        label: 'Produção'
      },
      tombamento: {
        color: 'primary',
        icon: 'fa-calendar-alt',
        label: 'Tombamento'
      },
      renegociacao: {
        color: 'info',
        icon: 'fa-calendar-check',
        label: 'Renegociacao'
      }
    };

    return map[tipo] || {
      color: 'secondary',
      icon: 'fa-calendar',
      label: tipo
    };
  }

}
